import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

function calcAge(d) {
  const t = new Date(), b = new Date(d);
  let a = t.getFullYear() - b.getFullYear();
  const m = t.getMonth() - b.getMonth();
  if (m < 0 || (m===0 && t.getDate()<b.getDate())) a--;
  return a;
}

export default function Signup() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ name:'', birthdate:'', gender:'', intention:'', orientation:'', orientationConsent:false, email:'', password:'', confirmPassword:'', termsAccepted:false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => { setForm(f => ({...f, [k]:v})); setError(''); };
  const age = form.birthdate ? calcAge(form.birthdate) : null;

  const next1 = () => {
    if (!form.name.trim()) return setError('Enter your first name');
    if (!form.birthdate || age < 18) return setError('You must be at least 18');
    if (!form.gender) return setError('Select your gender');
    if (!form.intention) return setError('Select what you are looking for');
    setStep(2);
  };

  const submit = async e => {
    e.preventDefault();
    if (!form.termsAccepted) return setError('Please accept the terms of service');
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    if (form.password !== form.confirmPassword) return setError('Passwords do not match');
    setLoading(true); setError('');
    const { error } = await supabase.auth.signUp({
      email: form.email, password: form.password,
      options: { data: { name: form.name, birthdate: form.birthdate, age: calcAge(form.birthdate), gender: form.gender, intention: form.intention, orientation: form.orientationConsent ? form.orientation : null, orientation_consent: form.orientationConsent }}
    });
    if (error) setError(error.message);
    else setStep(3);
    setLoading(false);
  };

  const inputStyle = { width:'100%', padding:'13px 16px', background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'12px', color:'white', fontSize:'0.9rem', outline:'none', colorScheme:'dark' };
  const chip = (active, label, onClick) => <button type="button" onClick={onClick} style={{ padding:'8px 15px', background: active?'white':'rgba(255,255,255,0.05)', border:`1px solid ${active?'white':'rgba(255,255,255,0.08)'}`, borderRadius:'100px', color: active?'#080808':'rgba(255,255,255,0.45)', fontSize:'0.82rem', fontWeight: active?600:400, cursor:'pointer' }}>{label}</button>;

  return (
    <div style={{ minHeight:'100vh', background:'#080808', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' }}>
      <div style={{ width:'100%', maxWidth:'420px', animation:'fadeIn 0.4s ease' }}>
        <div style={{ textAlign:'center', marginBottom:'28px' }}>
          <div onClick={() => navigate('/')} style={{ fontSize:'1.5rem', fontWeight:700, color:'white', marginBottom:'6px', cursor:'pointer' }}>
            near<span style={{ color:'rgba(255,255,255,0.3)' }}>me</span>
          </div>
          <p style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.85rem' }}>
            {step===1 && 'Step 1 of 2 — About you'}
            {step===2 && 'Step 2 of 2 — Your account'}
          </p>
        </div>

        {step < 3 && (
          <div style={{ display:'flex', gap:'6px', marginBottom:'20px' }}>
            {[1,2].map(s => <div key={s} style={{ flex:1, height:'2px', borderRadius:'2px', background: step>=s?'white':'rgba(255,255,255,0.08)' }}/>)}
          </div>
        )}

        <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'22px', padding:'26px' }}>
          {error && <div style={{ background:'rgba(255,50,50,0.08)', border:'1px solid rgba(255,50,50,0.14)', borderRadius:'9px', padding:'11px', color:'#ff6b6b', marginBottom:'14px', fontSize:'0.82rem' }}>{error}</div>}

          {step===1 && (
            <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
              <input placeholder="First name" value={form.name} onChange={e => set('name', e.target.value)} style={inputStyle}/>
              <div>
                <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.7rem', marginBottom:'6px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>Date of birth</label>
                <input type="date" value={form.birthdate} onChange={e => set('birthdate', e.target.value)}
                  max={new Date(new Date().setFullYear(new Date().getFullYear()-18)).toISOString().split('T')[0]}
                  style={inputStyle}/>
                {age !== null && <div style={{ fontSize:'0.75rem', marginTop:'4px', color: age>=18?'#00d68f':'#ff6b6b' }}>
                  {age>=18 ? `${age} years old` : `${age} years old — must be 18+`}
                </div>}
              </div>
              <div>
                <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.7rem', marginBottom:'7px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>I am a</label>
                <div style={{ display:'flex', gap:'7px', flexWrap:'wrap' }}>
                  {['Man','Woman','Non-binary','Other'].map(g => chip(form.gender===g, g, () => set('gender',g)))}
                </div>
              </div>
              <div>
                <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.7rem', marginBottom:'7px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>I am looking for</label>
                <div style={{ display:'flex', gap:'7px', flexWrap:'wrap' }}>
                  {['Relationship','Something casual','Friendship','Not sure yet'].map(i => chip(form.intention===i, i, () => set('intention',i)))}
                </div>
              </div>
              <div>
                <label style={{ color:'rgba(255,255,255,0.25)', fontSize:'0.7rem', marginBottom:'7px', display:'block', textTransform:'uppercase', letterSpacing:'0.8px' }}>Sexual orientation (optional)</label>
                <div style={{ display:'flex', gap:'7px', flexWrap:'wrap', marginBottom:'10px' }}>
                  {['Straight','Gay','Lesbian','Bisexual','Pansexual','Other'].map(o => chip(form.orientation===o, o, () => set('orientation',o)))}
                </div>
                {form.orientation && (
                  <label style={{ display:'flex', alignItems:'flex-start', gap:'9px', cursor:'pointer' }}>
                    <input type="checkbox" checked={form.orientationConsent} onChange={e => set('orientationConsent', e.target.checked)} style={{ marginTop:'2px', accentColor:'white', flexShrink:0 }}/>
                    <span style={{ fontSize:'0.75rem', color:'rgba(255,255,255,0.28)', lineHeight:1.5 }}>I consent to processing my sexual orientation data (GDPR — never shared).</span>
                  </label>
                )}
              </div>
              <button onClick={next1} style={{ padding:'13px', background:'white', color:'#080808', border:'none', borderRadius:'11px', fontSize:'0.92rem', fontWeight:600, cursor:'pointer', marginTop:'4px' }}>Continue</button>
            </div>
          )}

          {step===2 && (
            <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
              <button type="button" onClick={() => setStep(1)} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.25)', fontSize:'0.82rem', textAlign:'left', cursor:'pointer', marginBottom:'4px' }}>Back</button>
              <input type="email" placeholder="Email address" value={form.email} onChange={e => set('email',e.target.value)} required style={inputStyle}/>
              <input type="password" placeholder="Password (6+ characters)" value={form.password} onChange={e => set('password',e.target.value)} required style={inputStyle}/>
              <input type="password" placeholder="Confirm password" value={form.confirmPassword} onChange={e => set('confirmPassword',e.target.value)} required style={inputStyle}/>
              <label style={{ display:'flex', alignItems:'flex-start', gap:'9px', cursor:'pointer', marginTop:'4px' }}>
                <input type="checkbox" checked={form.termsAccepted} onChange={e => set('termsAccepted',e.target.checked)} style={{ marginTop:'2px', accentColor:'white', flexShrink:0 }}/>
                <span style={{ fontSize:'0.75rem', color:'rgba(255,255,255,0.28)', lineHeight:1.5 }}>
                  I am 18+ and agree to the{' '}
                  <span onClick={() => window.open('/terms','_blank')} style={{ color:'rgba(255,255,255,0.6)', cursor:'pointer', textDecoration:'underline' }}>Terms</span>
                  {' '}and{' '}
                  <span onClick={() => window.open('/privacy','_blank')} style={{ color:'rgba(255,255,255,0.6)', cursor:'pointer', textDecoration:'underline' }}>Privacy Policy</span>.
                </span>
              </label>
              <button type="submit" disabled={loading} style={{ padding:'13px', background:'white', color:'#080808', border:'none', borderRadius:'11px', fontSize:'0.92rem', fontWeight:600, cursor:'pointer', opacity: loading?0.7:1, marginTop:'4px' }}>
                {loading ? 'Creating account...' : 'Create account'}
              </button>
            </form>
          )}

          {step===3 && (
            <div style={{ textAlign:'center', padding:'16px 0' }}>
              <div style={{ width:'52px', height:'52px', background:'rgba(0,214,143,0.1)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12L9 16L19 8" stroke="#00d68f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
              <h3 style={{ color:'white', marginBottom:'8px', fontSize:'1.1rem', fontWeight:700 }}>Check your email</h3>
              <p style={{ color:'rgba(255,255,255,0.3)', marginBottom:'22px', fontSize:'0.85rem', lineHeight:1.6 }}>
                Confirmation sent to<br/><strong style={{ color:'white' }}>{form.email}</strong>
              </p>
              <button onClick={() => navigate('/login')} style={{ padding:'11px 28px', background:'white', color:'#080808', border:'none', borderRadius:'11px', fontWeight:600, cursor:'pointer', fontSize:'0.88rem' }}>Go to login</button>
            </div>
          )}
        </div>

        {step < 3 && (
          <p style={{ textAlign:'center', color:'rgba(255,255,255,0.22)', marginTop:'16px', fontSize:'0.85rem' }}>
            Already have an account?{' '}
            <span onClick={() => navigate('/login')} style={{ color:'white', cursor:'pointer', fontWeight:500 }}>Sign in</span>
          </p>
        )}
      </div>
    </div>
  );
}
